import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const OuterWrapper = styled.section`
  text-align: center;
  display: flex;
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-position: center top;
  background-size: cover;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 3rem;
  background-color: ${({ backgroundColor }) => backgroundColor};
  ${({ theme }) => theme.mq.lg`
  padding: 4rem;
  `};
`;

const Title = styled.div`
  font-size: 2.375rem;
  color: ${({ color }) => color};
  line-height: 1.2;
  font-weight: 600;
  ${({ theme }) => theme.mq.lg`
    font-size: ${theme.fontSize(6)};
  `};
`;

const Subtitle = styled.div`
  font-size: ${({ theme }) => theme.fontSize(2)};
  font-weight: 400;
  max-width: 28.5rem;
  color: ${({ color }) => color};
`;

const GenericHeaderBlock = ({ fields: headerFields }) => {
  const { header } = headerFields;
  const { fields } = header;
  const { backgroundColor, color = "#FFFFFF", title, subtitle } = fields;
  return (
    <OuterWrapper
      backgroundColor={backgroundColor}
      backgroundImage={`https:${header?.fields?.backgroundImage?.fields?.file?.url}`}
    >
      <Title color={color}>{title}</Title>
      <Subtitle color={color}>{subtitle}</Subtitle>
    </OuterWrapper>
  );
};

export default GenericHeaderBlock;

GenericHeaderBlock.propTypes = {
  fields: PropTypes.shape({
    header: PropTypes.shape({
      fields: PropTypes.shape({
        backgroundColor: PropTypes.string,
        backgroundImage: PropTypes.object,
        color: PropTypes.string,
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string,
      }),
    }),
  }),
};

GenericHeaderBlock.defaultProps = {
  fields: PropTypes.shape({
    header: PropTypes.shape({
      fields: PropTypes.shape({
        backgroundColor: "#EAFDE7",
        backgroundImage: {},
        color: "#192617",
        title: "",
        subtitle: "",
      }),
    }),
  }),
};
